// extracted by mini-css-extract-plugin
export var title = "homepage-module--title--9f502";
export var titles = "homepage-module--titles--84f9a";